/**
 * ****************************************************************************
 * @description     :   store of 管理者ファイル管理
 * @created at      :   2024/07/29
 * @created by      :   ANS376 – daonx@ans-net.jp.co
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    user_id: '',
    user_name: '',
    user_kana: '',
    user_name_alias: '',
    user_kana_alias: '',
    department_cd: '',
    department_name: '',
    office_cd: '',
    office_name: '',
    password: '',
    email_address1: '',
    email_address2: '',
    authority_kubun: 0,
    banned: 0,
    controlCenter: 0,
    path_image: '',
    image: '',
    widget_1: 1,
    widget_1_cd: '',
    widget_1_name: '',
    widget_2: 1,
    widget_3: 1,
    widget_4: 1,
    widget_5: 1,
    widget_6: 1
};

export default {
    namespaced: true,
    state: {
        isSuccess: false,
        data: { ...dataInit },
        listKubun: [],
        selectOptionKey: ['id', 'content'],
        totalRows: 0,
        listData: [],
        data_select: {
            authority_kubun: [
                {
                    code: 0,
                    name: '一般'
                },
                {
                    code: 99,
                    name: '管理'
                }
            ],
            banned: [
                {
                    code: 1,
                    name: '使用可'
                },
                {
                    code: 2,
                    name: '禁止'
                }
            ],
            notify: [
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ],
                [
                    { code: 0, name: '通知する' },
                    { code: 1, name: '通知しない' }
                ]
            ],
            widget_1: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            widget_2: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            widget_3: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            widget_4: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            widget_5: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            widget_6: [
                {
                    code: 1,
                    name: '表示'
                },
                {
                    code: 2,
                    name: '非表示'
                }
            ],
            control_center: [
                {
                    code: 0,
                    name: '権限なし'
                },
                {
                    code: 1,
                    name: '権限あり'
                }
            ]
        },
        msgNoData: '該当するデータが存在しません。'
    },
    mutations: {
        clearData(state) {
            state.data = { ...dataInit };
        },
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.listData = [];
            state.totalRows = 0;
            state.msgNoData = '該当するデータが存在しません。';
        },
        setListData(state, data) {
            state.listData = data ?? [];
            state.msgNoData = '';
        },
        setData(state, data) {
            state.data = data ?? [];
        },
        setKubunTitle(state, data) {
            state.listKubun = data ?? [];
        },
        setTotalRows(state, data) {
            state.totalRows = data;
        },
        setPageNavigation(state, data) {
            state.data.pageNo = data.currentPage;
            state.data.pageSize = data.perPage;
        },
        setPageNo(state, data) {
            state.data.pageNo = data;
        }
    },
    actions: {
        getUserInfo(context, param) {
            try {
                repository.getUserInfo(param.body).then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        data.Data.widget_1 = 1;
                        data.Data.widget_1_cd = 1;
                        data.Data.widget_1_name = '承認一覧';
                        data.Data.widget_2 = 1;
                        data.Data.widget_2_cd = 6;
                        data.Data.widget_2_name = '売上統計';
                        data.Data.widget_3 = 1;
                        data.Data.widget_3_cd = 3;
                        data.Data.widget_3_name = '手配状況一覧';
                        data.Data.widget_4 = 1;
                        data.Data.widget_5 = 1;
                        data.Data.widget_6 = 1;
                        context.commit('setData', data.Data);
                        if (param.callback) {
                            param.callback(data);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get user info data screen: ' + e.message);
            }
        },
        store(context, input) {
            try {
                repository.store(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        getListTitle(context) {
            try {
                repository.getListTitle().then((res) => {
                    const { data } = res;
                    if (data.Code == 200) {
                        context.commit('setKubunTitle', data.Data[0]);
                    }
                });
            } catch (e) {
                console.log('Action get user info data screen: ' + e.message);
            }
        },
        saveListKubun(context, input) {
            try {
                repository.saveListKubun(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
    }
};
